/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Review_Status_Not_Changes_RequestedInputs */

const es_co2_error_review_status_not_changes_requested = /** @type {(inputs: Error_Review_Status_Not_Changes_RequestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este formulario no está esperando una versión correctiva.`)
};

/**

* @param {Error_Review_Status_Not_Changes_RequestedInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_review_status_not_changes_requested = /** @type {((inputs?: Error_Review_Status_Not_Changes_RequestedInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Review_Status_Not_Changes_RequestedInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_review_status_not_changes_requested(inputs)
});